import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <AppSection />
        <CommentsSection />
        <CarouselSection />
        <TopicsSection />
        <IndexSection />
        <RankingSection />
        <MediaSection />
        <UpdatesSection />
        <CardsSection />
        <ContactSection />
        <FAQSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}